'use es6';

import { SEQUENCE_ENROLLMENT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const SequenceEnrollment = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  objectTypeId: SEQUENCE_ENROLLMENT_TYPE_ID,
  referenceObjectType: 'SEQUENCE_ENROLLMENT_PROPERTIES'
});
export default SequenceEnrollment;